import React from 'react';
import { useQuery, useParameterizedQuery, useMutation } from 'react-fetching-library';
import Page from '../../components/Page';
import { Box, Card, CardContent, List, ListItem, ListItemText, IconButton, useMediaQuery, Menu, MenuItem, Typography, Stack, Divider } from '@mui/material';
import { downloadEssentialDocumentAction, checkEssentialDocumentAction } from '../../services/request';
import Scrollbar from '../../components/Scrollbar';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { plPL } from '@mui/x-data-grid';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import CheckIcon from '@mui/icons-material/Check';
import { workStandardStaffColumns } from '../../services/column-definitions';
import toast from 'react-hot-toast';
import { useStaff } from '../../pages/Staff';
import { useManager } from '../../pages/Manager';
import { useSelector } from 'react-redux';
import PDFPreviewModal from '../employee/applications/applicationForm/tabs/documents/PDFPreviewModal';

export default function StaffEssentialDocuments ({ manager }) {
  const { application, setApplication } = manager ? useManager() : useStaff();
  const { employeeId } = useSelector(state => state.app);
  const isMobile = useMediaQuery('(max-width:600px)');
  const { query } = useParameterizedQuery(downloadEssentialDocumentAction);
  const { mutate } = useMutation(checkEssentialDocumentAction);
  const [previewUrl, setPreviewUrl] = React.useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [menuRow, setMenuRow] = React.useState(null);

  const handleMenuOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setMenuRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuRow(null);
  };

  const handleDownload = async (row, preview = false) => {
    const { payload, error, loading } = await query(row.id);

    if (!error) {
      if (preview) {
        setPreviewUrl(window.URL.createObjectURL(payload));
      } else {
        const url = window.URL.createObjectURL(payload);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = url;
        a.download = `${row.file_name}`;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    } else {
      toast.error('Nie udało się pobrać szablonu');
    }
  };

  const handleCheckDocument = async row => {
    const { payload, error, loading } = await mutate(row.id);
    if (!error) {
      setApplication(prev => ({ ...prev, essential_documents: prev.essential_documents.map(ws => ws.id === payload.id ? payload : ws) }));
      toast.success('Potwierdzono zapoznanie z dokumentem');
    }
  };

  if (!application) {
    return null;
  }

  return (
    <Page title="Niezbędniki">
      <Card>
        <CardContent>
          {isMobile ? (
            <>
              <List>
                {application.essential_documents.map(row => (
                  <ListItem key={row.id} divider>
                    <ListItemText primary={<Typography><b>Dokument:</b> {row.name}</Typography>} secondary={<Stack direction="column">
                      <Divider flexItem />
                      <Typography><b>Plik:</b> {row.file_name}</Typography>
                      <Typography><b>Opis:</b> {row.description}</Typography>
                      <Typography><b>Kategoria:</b> {row.category_display}</Typography>
                    </Stack>} />
                    <IconButton onClick={event => handleMenuOpen(event, row)}>
                      <MoreVertIcon />
                    </IconButton>
                  </ListItem>
                ))}
              </List>
              <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                {menuRow?.can_preview && (
                  <MenuItem onClick={() => {
                    handleDownload(menuRow, true);
                    handleMenuClose();
                  }}>
                    <RemoveRedEyeIcon style={{ marginRight: 8 }} /> Pokaż
                  </MenuItem>
                )}
                <MenuItem onClick={() => {
                  handleDownload(menuRow);
                  handleMenuClose();
                }}>
                  <FileDownloadIcon style={{ marginRight: 8 }} /> Pobierz Plik
                </MenuItem>

                <MenuItem
                  disabled={menuRow?.employee_ids_checked.includes(employeeId)}
                  onClick={() => {
                    handleCheckDocument(menuRow);
                    handleMenuClose();
                  }}
                >
                  <CheckIcon style={{ marginRight: 8 }} /> {menuRow?.employee_ids_checked.includes(employeeId) ? 'Potwierdzono' : 'Potwierdź'}
                </MenuItem>

              </Menu>
            </>
          ) : (
            <Scrollbar>
              <Box sx={{ minWidth: { md: 800 }, mt: 4 }}>
                <DataGridPro
                  columns={workStandardStaffColumns(handleDownload, handleCheckDocument, employeeId, true)}
                  rows={application.essential_documents}
                  density="standard"
                  disableColumnMenu={true}
                  autoPageSize={false}
                  autoHeight={true}
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  pagination
                  components={{
                    Toolbar: null
                  }}
                  localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
                  disableSelectionOnClick

                />
              </Box>
            </Scrollbar>
          )}
        </CardContent>
      </Card>
      {previewUrl !== null ? <PDFPreviewModal url={previewUrl} handleClose={() => setPreviewUrl(null)}/> : null}
    </Page>
  );
};
